import script from "./SearchShippingHistoryDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchShippingHistoryDetail.vue?vue&type=script&setup=true&lang=ts"

import "./SearchShippingHistoryDetail.vue?vue&type=style&index=0&id=0dd750ce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dd750ce"]])

export default __exports__